import { isValidIndividualTask } from './IndividualTask';
export const individualTaskApiToIndividualTaskEntity = task => {
  if (!task) {
    throw new Error('Invalid task', {
      cause: {
        task
      }
    });
  }
  const convertedIndividualTask = {
    id: task.id,
    revision: task.revision,
    createdDate: task.createdDate ? new Date(task.createdDate) : undefined,
    updatedDate: task.updatedDate ? new Date(task.updatedDate) : undefined,
    conversationId: task.conversationId,
    source: task.source,
    status: task.status,
    statusDetails: task.statusDetails,
    supervisorConversationId: task.supervisorConversationId,
    executorConversationId: task.executorConversationId,
    notes: task.notes,
    logs: task.logs,
    manuallyCompleted: task.manuallyCompleted
  };
  if (isValidIndividualTask(convertedIndividualTask)) {
    return convertedIndividualTask;
  }
  throw new Error('Invalid task data', {
    cause: {
      convertedIndividualTask
    }
  });
};
//# sourceMappingURL=converters.js.map